module.exports = __webpack_public_path__ + "img/img-qrcode.6810bd6d.png";